import {
  GET_ADIB_PARTNERS_MONTHLY_SUMMARY,
  GET_ADIB_PARTNERS_MONTHLY_SUMMARY_SUCCESS,
  GET_ADIB_PARTNERS_MONTHLY_SUMMARY_ERROR,
  GET_ADIB_PARTNERS_MONTHLY_SUMMARY_EMPTY,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetAdibPartnersMonthlySummary = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADIB_PARTNERS_MONTHLY_SUMMARY:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_ADIB_PARTNERS_MONTHLY_SUMMARY_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case GET_ADIB_PARTNERS_MONTHLY_SUMMARY_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_ADIB_PARTNERS_MONTHLY_SUMMARY_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetAdibPartnersMonthlySummary;
